import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=167b576e&scoped=true&lang=pug&"
import script from "./AccountDetail.vue?vue&type=script&lang=js&"
export * from "./AccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=167b576e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b576e",
  null
  
)

export default component.exports